// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { SideNav } from './SideNav';
import { TopNav } from './TopNav';
import OfflineBanner from '../ui/OfflineBanner';

// Safe check — avoids window access during SSR / tests
const isMobileWidth = () =>
  typeof window !== 'undefined' && window.innerWidth < 768;

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileWidth);

  useEffect(() => {
    const onResize = () => {
      const mobile = isMobileWidth();
      setIsMobile(mobile);
      if (!mobile) setMobileOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <SideNav isOpen={mobileOpen} isMobile={isMobile} onClose={closeMobile} />

      {/* Main area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        {/* Top bar */}
        <TopNav onMenuClick={() => setMobileOpen((o) => !o)} />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
            <OfflineBanner />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
